export default __webpack_public_path__ + "static/media/delivery.441464e7.svg";